import React, { useEffect, useState } from "react";
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import {
  Button,
  FormControl,
  Box,
  OutlinedInput,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import CloseIcon from "@mui/icons-material/Close";
import { cloneProject, getPreProProjects } from '../../../redux/pre_processor/actions';
import "./cloneModal.scss";
const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  boxShadow: 24,
  p: 4,
};

export default function CloneModal({ open, onCloseClone }) {

  const [projectName, setProjectName] = useState("");
  const dispatch = useDispatch();
  const apiStatus = useSelector((state) => state?.prePro?.apiStatus);

  useEffect(() => {
    //dispatch(validateUserClear());
    if (apiStatus && apiStatus != undefined) {
      if (apiStatus.loading === true) {

      } if (apiStatus.loading === false) {

        if (apiStatus.next === true || apiStatus.message != null) {
          setTimeout(() => {
            onCloseClone(false)
            dispatch(getPreProProjects({
              type: "",
              formattedStartDate: "",
              formattedEndDate: "",
              status: "",
            }))
          }, 2000);
        }
      }
    }
  }, [apiStatus]);
  const handleProjectName = (name) => {

    setProjectName(name);
  }
  const submit = () => {
    dispatch(cloneProject(projectName));
  }

  return (
    <div>
      <Modal
        open={open}

      >
        <Box sx={style}>
          <CloseIcon
            // style={{float: "right"}}
            style={{ position: "absolute", right: "15px", top: "15px" }}
            onClick={() => onCloseClone()}
          />
          <Typography id="modal-modal-title"

            sx={{ mb: 2, mt: -2 }} variant="h8" component="h4">
            Clone Project
          </Typography>

          <FormControl fullWidth>
            <div className="clone" >
              {/* // <label>{messages.USER_NAME_AUTH}</label> */}
              <OutlinedInput
                size="small"
                fullWidth
                placeholder="Project Name"
                defaultValue={localStorage.projectName + "_clone"}
                onChange={(e) => handleProjectName(e.target.value)}
                sx={{ mr: 2 }}
              />
              <Button className="button-clone" onClick={submit}>Clone</Button>
            </div>

          </FormControl>
        </Box>
      </Modal>
    </div>
  );
}